import {bannersConstants} from '../constants/ActionTypes';

const initialState = {
  kinds: [],
  types: []
};

const miscellaneous = (state = initialState, action) => {
  const newState = state;
  switch (action.type) {

    case bannersConstants.INFO_GET:
      if (action.data) {
        newState.kinds = action.data.kinds;
        newState.types = action.data.types;
      }

      return newState;

    default:
      return state;
  }
};

module.exports = miscellaneous;



// WEBPACK FOOTER //
// ./reducers/miscellaneous.reducers.js